export enum PaymentDetailsFormFields {
    BANK_ACCOUNT = 'bankAccount',
    TAX_RATE = 'taxRate',
    EXPIRATION_DATE = 'expirationDate',
    PAYMENT_TYPE = 'paymentType',
}
